import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'workspace-layout-root',
  templateUrl: './workspace-layout.component.html',
  styleUrls: ['./workspace-layout.component.scss']
})
export class WorkspaceLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
